import { IconX } from "@tabler/icons-react";
import { CButton } from "@app/components/Common";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";

interface IProps {
  closeModal?: () => void;
}

const OrderModalHeader = ({ closeModal }: IProps) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: 38,
        width: "100%",
      }}
    >
      <div
        style={{
          fontWeight: 700,
          letterSpacing: '-0.48px',
          fontFamily: 'NanumSquareRound',
          fontSize: 16,
          color: '#fff',
          lineHeight: 1
        }}
      >
        {t("orderPlacementPreferences")}
      </div>
      <CButton
        icon={<IconX size={18} color={textw} />}
        style={{
          color: textw,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 18,
          height: 18,
          cursor: 'pointer',
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default OrderModalHeader;
